// const axios = require("axios").default;

// export const URL_BACKEND: String = "http://10.31.0.107:8000/api";
// export const URL_BACKEND: String = "http://10.205.5.50:8003/api";
// export const URL_BACKEND: String = "https://app.denonciation.bj:8003/api";

export const URL_BACKEND: string = "https://denonciation.bj/api";

// export function getInstitution(): Promise<string[]> {
//   return axios.get(`${URL_BACKEND}/institutions-lite`);
// }

// export function upload2(formData: FormData, config: any): Promise<string[]> {
//   return axios.post(`${URL_BACKEND}/addfile`, formData, config, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
// }

// export function complementSubmit(result:any){
//     axios
//           .post(
//             `${URL_BACKEND}/denonciation/${store.getters.ps}`,
//             result
//           )
// }

// export function follow(reference:string,date:string): Promise<string[]> {
//     return axios.get(`${URL_BACKEND}/denonciation/${reference}/${date}`);
//   }
